export default __webpack_public_path__ + "static/media/pubg_banner_highlight.b091aa5b.png";